import React from "react";
import "../../../../pages/D09_Engagement_Questions_Sorted.css";

const EngagementTable = ({ data, sortOrder, toggleSortOrder, searchTerm }) => {
  return (
    <div
      className="engagement-table-container"
      style={{ width: "100%" }}
    >
      <table className="engagement-table">
        <thead>
          <tr>
            <th>Question</th>
            <th>Engagement Area</th>
            <th onClick={toggleSortOrder} style={{ cursor: "pointer" }}>
              Average {sortOrder === "asc" ? "▲" : "▼"}
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.question}</td>
              <td>{item.area}</td>
              <td>{item.average.toFixed(2)}</td> {/* Format to one decimal place */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EngagementTable;
